import { useEffect, useState, useMemo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactGA from "react-ga4";
import {
  getDMAInfo,
  setTransferDialogOpen,
  setAgentBuyDialogOpen
} from "../../../redux/slices/DMA";
import WheelDialog from "../../../components/Dialogs/WheelDialog";
import TransferDialog, { TransferSuccessDialog } from "../../../components/Dialogs/TransferDialog";
import { getUserInfo } from "../../../redux/slices/auth";

import { useHistory } from "react-router-dom";
import { displayNum, toFixed } from "../../../utils/strings";
import { currencies } from "../../../constants/currencies";
import { getOneTicket } from "../../../redux/slices/DMA";
import { getTransitionList } from "../../../redux/slices/one";
import Pagination from "../../../components/Pagination";

import {
  Box,
  Card,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Tabs,
  Tab,
  Container,
  Chip,
  IconButton,
  Tooltip,
  tooltipClasses,
  useMediaQuery
} from "@mui/material";
import { styled } from "@mui/material/styles";
import AgentCardImage from "../../../assets/icons/dashboard/agent-card2.png";
import { ReactComponent as DepositIcon } from "../../../assets/icons/dashboard/deposit.svg";
import { ReactComponent as WithdrawIcon } from "../../../assets/icons/dashboard/withdraw.svg";
import { ReactComponent as LogoIcon } from "../../../assets/icons/dashboard/logo.svg";
import SunBgImage from "../../../assets/icons/dashboard/sun-bg.png";
import { ReactComponent as SwapIcon } from "../../../assets/icons/dashboard/subtract.svg";
import LineBgImage from "../../../assets/icons/dashboard/lines-bg.png";
import { ReactComponent as EmptyIcon } from "../../../assets/icons/dashboard/empty.svg";

import { tableCellClasses } from "@mui/material/TableCell";
import AgentBuyDialog from "../../../components/Dialogs/AgentBuyDialog";
import { config } from "../../../config";
import HintDialog from "../../../components/Dialogs/HintDialog";

// 自定义样式
const StyledCard = styled("div")(({ theme }) => ({
  borderRadius: "16px",
  // background: "linear-gradient(180deg, rgba(239, 111, 23, 0.50) 0%, rgba(239, 111, 23, 0.00) 100%)",
  // backgroundBlendMode: "screen, normal, normal",

  background: `
    linear-gradient(180deg, rgba(239, 111, 23, 0.50) 0%, rgba(239, 111, 23, 0.00) 100%),
    url(${LineBgImage})
  `,
  padding: "50px",
  width: "456px",
  fontFamily: "Canva Sans Sans",
  position: "relative",

  // backgroundImage: `url(${LineBgImage})`,
  backgroundSize: "auto",
  backgroundRepeat: "repeat",
  backgroundPosition: "center",
  "background-blend-mode": "screen, normal, normal",

  [theme.breakpoints.down("sm")]: {
    padding: "16px",
    width: "100%",
    borderRadius: "8px"
  }
}));

const AgentStyledCard = styled("div")(({ theme }) => ({
  borderRadius: "16px",
  background: "transparent",
  backgroundBlendMode: "screen, normal, normal",
  border: "0.5px solid rgba(255, 135, 54, 0.5)",
  position: "relative",
  fontFamily: "Canva Sans Sans",
  width: "750px",

  [theme.breakpoints.down("sm")]: {
    width: "100%",
    borderRadius: "8px"
  }
}));

const BalanceValue = styled(Typography)(({ theme }) => ({
  fontSize: "40px",
  fontWeight: "400",
  marginTop: "40px",
  display: "flex",
  alignItems: "center",
  fontFamily: "Canva Sans Sans",

  [theme.breakpoints.down("sm")]: {
    marginTop: "12px",
    fontSize: "24px"
  }
}));

const UsdValue = styled(Typography)(({ theme }) => ({
  color: "#FF8736",
  fontSize: "14px",
  fontWeight: "400",
  marginTop: "10px",
  fontFamily: "Canva Sans Sans",
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  gap: "10px",

  [theme.breakpoints.down("sm")]: {
    marginTop: "8.5px",
    fontSize: "13px"
  }
}));

const StyledTableHeadRow = styled(TableRow)(({ theme }) => ({
  border: "0.5px solid #FF8736 !important",
  backgroundColor: "transparent !important",
  fontFamily: "Canva Sans Sans"
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  color: "white",
  borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
  padding: "20px 30px",
  backgroundColor: "#000",
  fontFamily: "Canva Sans Sans",

  [`&.${tableCellClasses.head}`]: {
    color: "#FF8736",
    fontSize: 14,
    fontWeight: "500",
    // `url(${LineBgImage}) rgba(255, 135, 54, 0.3)`,
    // background: ` rgba(255, 135, 54, 0.4)`,
    // "background-blend-mode": "soft-light, normal, normal",
    background: `
    linear-gradient(0, rgba(255, 135, 54, 0.30) 0%, rgba(255, 135, 54, 0.30) 100%),
    url(${LineBgImage})
  `,
    border: "none"
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14
  },

  [theme.breakpoints.down("sm")]: {
    padding: "10px 20px",
    [`&.${tableCellClasses.head}`]: {
      fontSize: 12
    }
  }
}));

const StatusChip = styled(Chip)(({ status }) => ({
  // backgroundColor:
  //   status === "LISTED"
  //     ? "rgba(255, 165, 0, 0.2)"
  //     : status === "WAKENING"
  //     ? "rgba(255, 255, 0, 0.2)"
  //     : "rgba(0, 255, 0, 0.2)",
  color: status === "LISTED" ? "orange" : status === "WAKENING" ? "yellow" : "#25A750",
  borderRadius: 4
}));

const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "3323232", // 自定义背景色
    borderRadius: "4px", // 自定义圆角
    padding: "10px",
    fontSize: "12px"
  }
}));

const ClaimButton = styled(Button)(({ theme, variant }) => ({
  backgroundColor: variant === "outlined" ? "transparent" : "orange",
  border: variant === "outlined" ? "1px solid rgba(255, 255, 255, 0.3)" : "none",
  color: "white",
  "&:hover": {
    backgroundColor: variant === "outlined" ? "rgba(255, 255, 255, 0.1)" : "darkorange"
  }
}));

const ProfitValue = styled(Typography)(({ positive }) => ({
  color: positive ? "#25A750" : "#CA3F64",
  display: "inline-block",
  fontFamily: "Canva Sans Sans"
}));

function DMAView() {
  const [tabValue, setTabValue] = useState(0);
  const [tabHistoryValue, setTabHistoryValue] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const { balance: delysiumBalance, oneTicket } = useSelector((state) => state.DMA);
  const { userInfo } = useSelector((state) => state.auth);
  const { transactionList } = useSelector((state) => state.one);
  const [page, setPage] = useState(1);

  function handleChangePage(e, value) {
    setPage(value);
    dispatch(getTransitionList(value));
  }

  const oneBalance = useMemo(() => {
    return userInfo?.Stat?.balance_agi || 0;
  }, [userInfo?.Stat?.balance_agi]);

  useEffect(() => {
    // if (!userInfo) {
    dispatch(getUserInfo());
    dispatch(getOneTicket());
    dispatch(getTransitionList(page));
    // }
  }, []);

  // useEffect(() => {
  //   if (oneTicket && !oneTicket?.exists) {
  //     dispatch(setAgentBuyDialogOpen(true));
  //   }
  //   // dispatch(setAgentBuyDialogOpen(true));
  // }, [oneTicket]);

  // 模拟数据
  const agents = useMemo(() => {
    return userInfo?.token_list || [];
  }, [userInfo?.token_list]);
  // 模拟交易历史数据
  // const tradeHistory = [
  //   {
  //     time: "Jan 12 2025 12:12:12",
  //     pair: "BTC/AGI",
  //     side: "Buy",
  //     price: "0.0123",
  //     filled: "9.9999 BTC",
  //     fee: "0.99 AGI",
  //     total: "99.99 USDT"
  //   },
  //   // ... 更多数据
  // ];
  const tradeHistory = useMemo(() => {
    return (transactionList?.list || [])?.map((item) => {
      return {
        time: item.create_time,
        pair: item.token_name ? `${item.token_name}/AGI` : "AGI",
        side: item.side === 1 ? "Buy" : "Sell",
        price: toFixed(item.price, 6),
        filled: displayNum(item.filled),
        fee: item.fee,
        total: item.total
      };
    });
  }, [transactionList]);

  const dispatch = useDispatch();
  const { push } = useHistory();
  const { user } = useSelector((state) => state.auth);

  const { transferDialogOpen, agentBuyDialogOpen } = useSelector((state) => state.DMA);
  useEffect(() => {
    dispatch(getDMAInfo());
  }, [dispatch]);

  function handleClickWithdraw(initialCurrency = currencies.USDT) {
    push("/trade?type=withdraw");
  }

  async function handleClickDeposit() {
    push("/trade?type=deposit");
  }

  function handleClickTransfer() {
    if (oneTicket && !oneTicket?.exists) {
      dispatch(setAgentBuyDialogOpen(true));
      return;
    }
    ReactGA.event("try_dmatransferAGI");
    dispatch(setTransferDialogOpen(true));
  }

  const statusMap = {
    0: "LISTED",
    1: "WAKENING",
    2: "WAKENED"
  };

  return (
    <Container
      sx={{
        paddingTop: isMobile ? "0" : "50px",
        paddingBottom: "100px",
        paddingLeft: isMobile ? "0px" : "16pX",
        paddingRight: isMobile ? "0px" : "16pX"
      }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          justifyContent: isMobile ? "flex-start" : "center",
          gap: isMobile ? "12px" : "10px",
          position: "relative",
          mb: 4
        }}>
        <Box
          sx={{
            display: "block",
            position: "absolute",
            top: isMobile ? "-26px" : "-50px",
            left: 0,
            width: isMobile ? "100%" : "100vw",
            height: "290px",
            backgroundRepeat: "no-repeat",
            backgroundSize: isMobile ? "contain" : "cover",
            backgroundImage: `url(${SunBgImage})`
          }}></Box>
        {/* 账户余额卡片 */}
        <StyledCard>
          <Typography
            variant="h6"
            mb={2}
            fontFamily={"Canva Sans Sans"}
            letterSpacing={1.6}
            fontSize={isMobile ? 14 : 20}
            fontWeight={400}>
            ACCOUNT BALANCE
          </Typography>
          <BalanceValue>
            <Box
              sx={{
                "border-radius": "50%",
                background: "#000",
                width: isMobile ? "32px" : "40px",
                height: isMobile ? "32px" : "40px",
                marginRight: "10px",
                padding: "0px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}>
              <LogoIcon />
            </Box>
            <Box
              sx={{
                width: "305px",
                texteOverflow: "ellipsis",
                overflow: "hidden",
                fontSize: isMobile ? "24px" : "40px"
              }}
              title={displayNum(userInfo?.dely_balance_agi || 0)}>
              {displayNum(userInfo?.dely_balance_agi || 0)}
            </Box>
          </BalanceValue>
          <UsdValue>
            <Box sx={{ marginLeft: isMobile ? 0 : "16px" }}>
              ≈{displayNum(userInfo?.dely_balance_agi_usd || 0)} USD
            </Box>
          </UsdValue>
          <Box>
            <Box
              display="flex"
              gap={2}
              sx={{
                mt: isMobile ? "20px" : "90px"
              }}>
              <Button
                sx={{
                  borderRadius: "8px",
                  backgroundColor: "#000",
                  color: "#fff",
                  height: "60px",
                  width: "168px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transition: "all 0.3s"
                }}
                onClick={handleClickDeposit}>
                <DepositIcon />
                <Typography sx={{ marginLeft: "4px" }} fontFamily={"Canva Sans Sans"}>
                  DEPOSIT
                </Typography>
              </Button>
              <Button
                sx={{
                  borderRadius: "8px",
                  backgroundColor: "#000",
                  color: "#fff",
                  height: "60px",
                  width: "168px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transition: "all 0.3s"
                }}
                onClick={handleClickWithdraw}>
                <WithdrawIcon />
                <Typography sx={{ marginLeft: "4px" }} fontFamily={"Canva Sans Sans"}>
                  WITHDRAW
                </Typography>
              </Button>
            </Box>
            <Box mt={"16px"} display="flex" gap={2}>
              <Button
                sx={{
                  borderRadius: "8px",
                  backgroundColor: isMobile ? "rgba(255, 135, 54, 1)" : "rgba(255, 135, 54, 0.3)",
                  color: isMobile ? "#000" : "rgba(255, 135, 54, 1)",
                  height: "60px",
                  width: "352px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transition: "all 0.3s",
                  "&:hover": {
                    backgroundColor: "rgba(255, 135, 54, 1)",
                    color: "#000"
                  }
                }}
                onClick={handleClickTransfer}>
                <SwapIcon />
                <Typography sx={{ marginLeft: "4px" }} fontFamily={"Canva Sans Sans"}>
                  TRANSFER
                </Typography>
              </Button>
            </Box>
          </Box>
        </StyledCard>

        {/* 代理余额卡片 */}
        <AgentStyledCard>
          <Box
            sx={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              justifyContent: isMobile ? "flex-start" : "space-between",
              alignItems: isMobile ? "center" : "flex-start"
            }}>
            <Box
              sx={{
                padding: isMobile ? "16px" : "50px 30px 50px 50px",
                minWidth: 380
              }}>
              <Typography
                variant="h6"
                mb={2}
                fontFamily={"Canva Sans Sans"}
                letterSpacing={1.6}
                fontSize={20}
                fontWeight={400}>
                AGENT BALANCE
              </Typography>
              <BalanceValue>
                <Box
                  sx={{
                    "border-radius": "50%",
                    background: "#000",
                    width: "40px",
                    height: "40px",
                    marginRight: "10px",
                    padding: "0px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}>
                  <LogoIcon />
                </Box>
                {displayNum(userInfo?.balance_agi)}
              </BalanceValue>
              <UsdValue>
                <Box sx={{ marginLeft: "16px" }}>≈{displayNum(userInfo?.balance_agi_usd)} USD</Box>
              </UsdValue>
              <Typography
                variant="caption"
                sx={{ display: "block", mt: "30px" }}
                fontSize={14}
                fontWeight={400}
                fontFamily={"Canva Sans Sans"}>
                Agent ID #{oneTicket?.ticket_id || ""}
              </Typography>
              <Typography
                variant="body2"
                sx={{ mt: 2, opacity: 0.6 }}
                fontSize={14}
                fontWeight={400}
                lineHeight={1.5}
                fontFamily={"Canva Sans Sans"}>
                All trades on Delysium ONE are executed by AI agents through Agent Balance. To get
                started, please transfer $AGI tokens from your Account Balance to your Agent
                Balance.
              </Typography>
            </Box>
            <Box
              component="img"
              src={AgentCardImage}
              sx={{ width: 356, objectFit: "contain", paddingRight: "10px", zIndex: "-1" }}
            />
          </Box>
        </AgentStyledCard>
      </Box>

      {/* 导航标签 */}
      <Box
        sx={{
          margin: "50px auto 10px",
          width: isMobile ? "100%" : "1216px"
        }}>
        <Tabs
          value={tabValue}
          onChange={(e, newValue) => setTabValue(newValue)}
          indicatorColor="transparent"
          textColor="inherit">
          <Tab
            label="MY ASSET"
            sx={{
              fontFamily: "Canva Sans Sans",
              fontSize: isMobile ? "14px" : "20px",
              fontWeight: "normal"
            }}
          />
          <Tab
            label="TRADE HISTORY"
            sx={{
              fontFamily: "Canva Sans Sans",
              fontSize: isMobile ? "14px" : "20px",
              fontWeight: "normal"
            }}
          />
        </Tabs>
      </Box>
      {tabValue === 1 && (
        <Box
          mb={"10px"}
          sx={{
            color: "#FF8736",
            margin: "0 auto 10px",
            width: isMobile ? "100%" : "1216px"
          }}>
          <Tabs
            value={tabHistoryValue}
            onChange={(e, newValue) => setTabHistoryValue(newValue)}
            indicatorColor="transparent"
            sx={{
              color: "rgba(255, 255, 255, 1)"
            }}>
            <Tab
              label="LISTED"
              sx={{
                fontFamily: "Canva Sans Sans",
                fontSize: isMobile ? "14px" : "20px",
                fontWeight: "normal"
              }}
            />
            <Tab
              label="LAUNCHING"
              sx={{
                fontFamily: "Canva Sans Sans",
                fontSize: isMobile ? "14px" : "20px",
                fontWeight: "normal"
              }}
            />
          </Tabs>
        </Box>
      )}

      {tabValue === 1 && tabHistoryValue === 0 && (
        <TableContainer
          component={Paper}
          sx={{ bgcolor: "transparent", width: isMobile ? "100%" : "1216px", margin: "0 auto" }}>
          <Table sx={{ minWidth: 650 }}>
            <TableHead>
              <StyledTableHeadRow>
                <StyledTableCell>Time</StyledTableCell>
                <StyledTableCell>Side</StyledTableCell>
                <StyledTableCell>Price</StyledTableCell>
                <StyledTableCell>Filled</StyledTableCell>
                <StyledTableCell>Fee</StyledTableCell>
                <StyledTableCell>Total</StyledTableCell>
              </StyledTableHeadRow>
            </TableHead>
            <TableBody
              sx={{
                border: "0.5px solid #323232"
              }}>
              <TableRow>
                <StyledTableCell colSpan={6}>
                  <Box
                    sx={{
                      width: "100%",
                      padding: "110px 0",
                      margin: "0 auto",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      flexDirection: "column"
                    }}>
                    <EmptyIcon />
                    <Typography
                      sx={{
                        mt: "8px",
                        fontSize: "14px",
                        fontWeight: 500,
                        color: "rgba(255,255,255,0.4)"
                      }}>
                      You Know I love You
                    </Typography>
                  </Box>
                </StyledTableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {/* 交易历史表格 */}
      {tabValue === 1 && tabHistoryValue === 1 ? (
        <TableContainer
          component={Paper}
          sx={{ bgcolor: "transparent", width: isMobile ? "100%" : "1216px", margin: "0 auto" }}>
          <Table sx={{ minWidth: 650 }}>
            <TableHead>
              <StyledTableHeadRow>
                <StyledTableCell>Time</StyledTableCell>
                <StyledTableCell>Pair</StyledTableCell>
                <StyledTableCell>Side</StyledTableCell>
                <StyledTableCell>Price</StyledTableCell>
                <StyledTableCell>Filled</StyledTableCell>
                <StyledTableCell>Fee</StyledTableCell>
                <StyledTableCell>Total</StyledTableCell>
              </StyledTableHeadRow>
            </TableHead>
            <TableBody
              sx={{
                border: "0.5px solid #323232"
              }}>
              {tradeHistory?.length ? (
                tradeHistory.map((row, index) => (
                  <TableRow key={index}>
                    <StyledTableCell>{row.time}</StyledTableCell>
                    <StyledTableCell>{row.pair}</StyledTableCell>
                    <StyledTableCell sx={{ color: row.side === "Buy" ? "#25A750" : "#CA3F64" }}>
                      {row.side}
                    </StyledTableCell>
                    <StyledTableCell>{row.price}</StyledTableCell>
                    <StyledTableCell>
                      {row.filled} {row.token_name}
                    </StyledTableCell>
                    <StyledTableCell>{row.fee}</StyledTableCell>
                    <StyledTableCell>{row.total} AGI</StyledTableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <StyledTableCell colSpan={7}>
                    <Box
                      sx={{
                        width: "100%",
                        padding: "110px 0",
                        margin: "0 auto",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column"
                      }}>
                      <EmptyIcon />
                      <Typography sx={{ mt: "8px", fontSize: "14px", fontWeight: 500 }}>
                        You Know I love You
                      </Typography>
                    </Box>
                  </StyledTableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      ) : null}

      {tabValue === 1 && tabHistoryValue === 1 && transactionList?.total ? (
        <Pagination
          sx={{
            width: isMobile ? "100%" : "1216px",
            margin: isMobile ? "12px auto 0" : "20px auto 0"
          }}
          onChange={handleChangePage}
          count={Math.ceil(transactionList?.total / transactionList?.size)}
          page={page}
        />
      ) : null}
      {tabValue === 0 ? (
        <TableContainer
          sx={{
            border: "0.5px solid #323232",
            background: "#000",
            width: isMobile ? "100%" : "1216px",
            margin: "0 auto"
          }}>
          <Table sx={{ minWidth: 650 }}>
            <TableHead>
              <StyledTableHeadRow>
                <StyledTableCell>Agent</StyledTableCell>
                <StyledTableCell>Status</StyledTableCell>
                <StyledTableCell>Amount</StyledTableCell>
                <StyledTableCell>Coin Price</StyledTableCell>
                <StyledTableCell>24h Pnl</StyledTableCell>
              </StyledTableHeadRow>
            </TableHead>
            <TableBody
              sx={{
                border: "0.5px solid #323232"
              }}>
              {agents?.length ? (
                agents.map((agent) => (
                  <TableRow key={agent.id}>
                    <StyledTableCell>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Box
                          component="img"
                          src={agent.logo_url}
                          width={56}
                          height={56}
                          sx={{
                            mr: 2,
                            "clip-path": "polygon(10px 0, 100% 0, 100% 100%, 0 100%, 0 10px)",
                            cursor: "pointer"
                          }}
                          onClick={() => {
                            window.open(
                              `${config.DELYSIUM_ONE_CLIENT_URL}/votings/${agent.token_id}`
                            );
                          }}
                        />
                        <Typography
                          fontFamily={"Canva Sans Sans"}
                          sx={{
                            cursor: "pointer",
                            "&:hover": {
                              textDecoration: "underline"
                            }
                          }}
                          onClick={() => {
                            window.open(
                              `${config.DELYSIUM_ONE_CLIENT_URL}/votings/${agent.token_id}`
                            );
                          }}>
                          {agent.name}
                        </Typography>
                      </Box>
                    </StyledTableCell>
                    <StyledTableCell>
                      <StatusChip
                        label={statusMap[agent.status]}
                        status={statusMap[agent.status]}
                        size="small"
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <Typography fontFamily={"Canva Sans Sans"}>
                        {displayNum(agent.value)}
                      </Typography>
                      <Typography variant="caption" color="gray" fontFamily={"Canva Sans Sans"}>
                        ${displayNum(agent.balance)}
                      </Typography>
                    </StyledTableCell>
                    <StyledTableCell>
                      <Typography>${toFixed(agent.current_price, 6)}</Typography>
                    </StyledTableCell>
                    <StyledTableCell>
                      <ProfitValue positive={agent.pnl_24h > 0}>
                        {agent.pnl_24h > 0 ? "+" : ""}
                        {displayNum(agent.pnl_24h)}
                      </ProfitValue>
                    </StyledTableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <StyledTableCell colSpan={5}>
                    <Box
                      sx={{
                        width: "100%",
                        padding: "110px 0",
                        margin: "0 auto",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column"
                      }}>
                      <EmptyIcon />
                      <Typography sx={{ mt: "8px", fontSize: "14px", fontWeight: 500 }}>
                        You Know I love You
                      </Typography>
                    </Box>
                  </StyledTableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      ) : null}
      <WheelDialog />
      <TransferDialog
        open={transferDialogOpen}
        setClose={() => dispatch(setTransferDialogOpen(false))}
      />
      <AgentBuyDialog
        open={agentBuyDialogOpen}
        setClose={() => dispatch(setAgentBuyDialogOpen(false))}
      />
      <TransferSuccessDialog />
    </Container>
  );
}
export default DMAView;
